@import 'db-ui-core.general';
@import 'image';

figure {
  margin: 0;
}
